
// @ts-ignore
import {getConfig, getLanguageConfig} from "../../utils/config-helper";
// @ts-ignore
import {translate} from '@elements/translations';
import {ref, computed, watch, reactive, onMounted, defineComponent} from 'vue';
import {getSkiTicketBaseConfig} from "../../utils/config-helper";
import {getB2BSkiTicketBaseConfig} from "../../utils/config-helper";
import {addParamsToUrl, throwAlertMessage, assertData, fetcher, areEqualArrays, convertInCurrency} from "../../utils/utils";
import {ServicesStruct } from "../../utils/structs";
import OptionBox from "../boxes/OptionBox.vue";
import LoadingSpinner from "../loading/LoadingSpinner.vue";
import {PricingStruct } from "../../utils/structs";
import { useTicketStore } from "../../stores/TicketStore";
import { storeToRefs } from "pinia";

export default defineComponent({
    name: "TicketConfigurations",
    components: {
        OptionBox,
        LoadingSpinner
    },
    props: {
        hideTexts: {
            type: Boolean,
            required: false,
            default: false,
        },
        ticketId: {
            type: String,
            required: true,
        },
        selectedDateStart: {
            type: String,
            required: true,
        },
        selectedDateEnd: {
            type: String,
            required: true,
        },
        selectedOption: {
            type: String
        },
        selectedInsurance: {
            type: String
        },
        selectedUpgrades: {
            type: Array
        },
        selectedPriceGroup: {
            type: String
        },
        selectedCurrency: {
            type: String
        },
        changeUpgrades: {
            type: Function
        },
        changeOption: {
            type: Function
        },
        changeInsurance: {
            type: Function
        },
        changePriceConfiguration: {
            type: Function
        },
        changeTicketConfigurations: {
            type: Function
        },
        selectedPriceConfiguration: {
            type: Object
        },
        ticketConfigurations: {
            type: Object,
        },
        allPriceGroups: {
            type: Array
        },
        type: {
            type: String,
            required: false,
            default: 'ticket'
        },
        isInPriceCalculator: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    emits: ['changeOption', 'changePrice', 'changeInsurance', 'changeUpgrades', 'changeAllOptions', 'changeAllInsurances', 'changeAllUpgrades', 'changePriceConfiguration', 'changeTicketConfigurations','changeAllPriceGroups', 'changePriceGroup'],
    setup(props, {emit}) {

        const options = ref<object>([]);
        const insurances = ref<object>([]);
        const upgrades = ref<object>([]);
        const isLoading = ref<boolean>(true);
        const description = ref<String>(false);
        const priceGroups = ref<object>([]);
        const priceConfigurations = ref<object>([]);
        const price = ref<number>(0);

        const ticketStore = useTicketStore();
        const {
            preselectedOption,
            preselectedUpgrades
        } = storeToRefs(ticketStore);

        const fetchData = async () => {
            const params = {
                ticketId: props.ticketId,
                ...(props.selectedDateStart !== "" && {selectedDateStart: props.selectedDateStart}),
                ...(props.selectedDateEnd !== "" && {selectedDateEnd: props.selectedDateEnd}),
            };

            let url;
            switch(props.type) {
                case 'ticket':
                    url = getSkiTicketBaseConfig().services;
                    break;
                case 'b2b':
                    url = getB2BSkiTicketBaseConfig().services;
                    break;
                default:
                    url = getSkiTicketBaseConfig().services;
            }

            url = addParamsToUrl(url, new URLSearchParams(params));
            await fetcher(url).then((result) => {
                assertData(result, ServicesStruct, url, 'fetchData', 'danger');

                options.value = result.options;
                insurances.value = result.insurances;
                upgrades.value = result.upgrades;
                description.value = result.serviceDescription;

                emit('changeAllOptions', options.value);
                emit('changeAllInsurances', insurances.value);
                emit('changeAllUpgrades', upgrades.value);

                //prefill option
                if (props.selectedOption === undefined || props.selectedOption === "" || props.selectedOption === null) {
                    if(props.isInPriceCalculator && preselectedOption !== undefined && preselectedOption.value) {
                        emit('changeOption', preselectedOption.value);
                    } else {
                        emit('changeOption', options.value[0].id);
                    }
                }

                isLoading.value = false;
                upgradesForOption();
                insuranceForOption();

            }).catch((error) => {
                console.log(error);
            });
        };

        const getConfigurationPrice = () => {
            if(!props.selectedPriceGroup) {
                console.warn("selected priceGroup not defined:", props.selectedPriceGroup);
                return 0;
            }
            if(!props.selectedOption) {
                console.warn("selectedOption not defined:", props.selectedOption);
                return 0;
            }
            if(!props.selectedInsurance ) {
                console.warn("selectedInsurance not defined:", props.selectedInsurance);
                return 0;
            }

            let configuration = [];
            let configurationPrice = [];

            try {
                configuration = priceConfigurations.value.filter(config => config.option === props.selectedOption
                    &&  config.insurance === props.selectedInsurance
                    && areEqualArrays(config.upgrades, props.selectedUpgrades));

                emit('changePriceConfiguration', configuration[0]);
                configurationPrice = configuration[0].priceByPriceGroup.filter(config => config.id == props.selectedPriceGroup);

                if(configurationPrice) {
                    price.value = configurationPrice[0]?.price;
                } else {
                    price.value = 0;
                }

            } catch (error) {
                console.error(error);
                let message = `<strong>option</strong>: ${props.selectedOption}, <br><strong>insurance</strong>: ${props.selectedInsurance}, <br> <strong>upgrades:</strong> ${props.selectedUpgrades},  <br> <strong>priceGroup:</strong> ${props.selectedPriceGroup}`;
                throwAlertMessage("danger", "No priceConfig found", message + "<br>" + error, true);
                return 0;
            }

            emit('changePrice', price.value);
        }

        const fetchPrices = async () => {
            isLoading.value = true;

            const params = {
                ticketId: props.ticketId,
                ...(props.selectedDateStart !== "" && {selectedDateStart: props.selectedDateStart}),
                ...(props.selectedDateEnd !== "" && {selectedDateEnd: props.selectedDateEnd}),
            };

            let url;
            switch(props.type) {
                case 'ticket':
                    url = getSkiTicketBaseConfig().pricings;
                    break;
                case 'b2b':
                    url = getB2BSkiTicketBaseConfig().pricings;
                    break;
                default:
                    url = getSkiTicketBaseConfig().pricings;
            }
            url = addParamsToUrl(url, new URLSearchParams(params));
            await fetcher(url).then((result) => {
                assertData(result, PricingStruct, url, 'fetchPrices', 'danger');

                if(props.type === 'b2b') {
                    priceGroups.value = [];
                }

                result.priceGroups.forEach(function(element, index) {
                    priceGroups.value.push({
                        label: element.label,
                        labelPlural: element.labelPlural,
                        value: element.id,
                    })
                });

                priceConfigurations.value = result.priceConfigurations;
                emit('changeAllPriceGroups', priceGroups.value);

                if(!props.selectedPriceGroup || props.selectedPriceGroup === "") {
                    emit('changePriceGroup', priceGroups.value[0].value);
                }
                isLoading.value = false;

                let ticketConfig = props.ticketConfigurations;
                priceGroups.value.forEach((priceGroup) => {
                    if(ticketConfig['priceGroups'][priceGroup.value] === undefined){
                        ticketConfig['priceGroups'][priceGroup.value] = {};
                    }
                    ticketConfig['priceGroups'][priceGroup.value].counter = 0;
                });

                emit('changeTicketConfigurations', ticketConfig);
                getConfigurationPrice();
            }).then(() => {
                fetchData();
            }).catch((error) => {
                console.log(error);
            });
        };


        const onChangeOption = (option: String) => {
            emit('changeOption', option);
        }

        const onChangeInsurance = (insurance: String) => {
            emit('changeInsurance', insurance);
        }

        const onChangeUpgrades = (upgrades: String[]) => {
            emit('changeUpgrades', upgrades);
        }

        const getOptionObject = (optionId: String) => {
            return options.value.filter((option: any) => {
                return option.id === optionId;
            })[0];
        }

        const getInsurancesArray = (optionId: String, upgrades: String[]) => {
            let insurancesArray = [];
            priceConfigurations.value.filter((config: any) => {
                if(config.option === optionId && (areEqualArrays(config.upgrades, upgrades) || config.upgrades.length === 0 && upgrades.length === 0)) {
                    insurancesArray.push(config.insurance);
                }
            });

            return insurancesArray;
        }

        const services = reactive({
            insuranceForOption: null,
            upgradesForOption: null
        });

        const upgradesForOption = () => {
            if (typeof props.selectedOption === undefined || props.selectedOption === "") {
                return [];
            }

            let upgradesArray = upgrades.value.filter((upgrade: any) => {
                return getOptionObject(props.selectedOption).upgrades.includes(upgrade.id);
            });

            if(upgradesArray.length === 0) {
                emit('changeUpgrades', []);
            } else if(props.selectedUpgrades.length > 0){
                //check if selected upgrades are still valid
                let upgradesNotIncluded = props.selectedUpgrades.filter((upgrade: any) => {
                    return !getOptionObject(props.selectedOption).upgrades.includes(upgrade);
                });
                //if not, remove them
                if(upgradesNotIncluded.length > 0) {
                    let tempSelectedArray = props.selectedUpgrades;
                    //remove upgradesNotIncluded from props.selectedUpgrades array
                    upgradesNotIncluded.forEach((upgrade: any) => {
                        let index = props.selectedUpgrades.indexOf(upgrade);
                        if (index > -1) {
                            tempSelectedArray.splice(index, 1);
                        }
                    });
                    emit('changeUpgrades', tempSelectedArray);
                }
            }

            services.upgradesForOption =  upgradesArray;
        };

        const insuranceForOption = () => {
            if (typeof props.selectedOption === undefined || props.selectedOption === "") {
                return [];
            }

            let tempInsurances = insurances.value.filter((insurance: any) => {
                return getInsurancesArray(props.selectedOption, props.selectedUpgrades)?.includes(insurance.id);
            });

            tempInsurances.push({
                id: "no_insurance",
                label: translate('shop.ticket.No-insurance')
            });

             if(props.selectedInsurance !== 'no_insurance') {
                //check if selected insurance is still valid
                if(!getInsurancesArray(props.selectedOption, props.selectedUpgrades).includes(props.selectedInsurance)) {
                    emit('changeInsurance', "no_insurance");
                }
            }

            services.insuranceForOption =  tempInsurances;
        };

        const getPriceDifferenceOptions = (newOption) => {
            return getPriceDifference(newOption, props.selectedInsurance, props.selectedUpgrades);
        }

        const getPriceDifferenceInsurance = (newInsurance) => {
            return getPriceDifference(props.selectedOption, newInsurance, props.selectedUpgrades);
        }

        const getPriceDifferenceUpgrades = (newUpgrades) => {
            let upgrades = [...props.selectedUpgrades];
            upgrades.push(newUpgrades);
            upgrades = [...new Set(upgrades)];

            return getPriceDifference(props.selectedOption, props.selectedInsurance, upgrades);
        }

        const getPriceDifference = (newOption, newInsurance, newUpgrades) => {
            let priceDifference = 0;

            try {
                let currentPrice = props.selectedPriceConfiguration['priceByPriceGroup']?.filter(config => config.id == props.selectedPriceGroup)[0].price;

                let configuration = [];
                let configurationPrice = [];
                configuration = priceConfigurations.value?.filter(config => config.option === newOption
                    &&  config.insurance === newInsurance
                    && areEqualArrays(config.upgrades, newUpgrades));

                configurationPrice = configuration[0]?.priceByPriceGroup?.filter(config => config.id == props.selectedPriceGroup)[0];
                priceDifference = configurationPrice?.price - currentPrice;
            } catch (e) {
                console.warn("ERROR", e);
            }

            return priceDifference;
        };

        onMounted(() => {
            fetchPrices();
        });

        watch(() => props.selectedDateEnd, () => {
            if (props.type === 'b2b') {
                fetchPrices();
            }
        });

        watch(() => props.selectedOption, () => {
            insuranceForOption();
            upgradesForOption();
        });

        watch(() => props.selectedUpgrades, () => {
            insuranceForOption();
            getConfigurationPrice();
        });

        watch(() => [props.selectedCurrency, props.selectedOption, props.selectedInsurance, props.selectedPriceGroup], () => {
            getConfigurationPrice();
        })

        return {
            options,
            insurances,
            upgrades,
            onChangeOption,
            onChangeInsurance,
            onChangeUpgrades,
            upgradesForOption,
            insuranceForOption,
            services,
            description,
            translate,
            getPriceDifference,
            getPriceDifferenceInsurance,
            getPriceDifferenceUpgrades,
            getPriceDifferenceOptions,
            isLoading
        }
    }
})
